import axios from 'axios';
import { rootUrl } from '../../../config/config';

export const fetchPrintableJobCard = async (token, jobCardId) => {
  const response = await axios.get(
    `${rootUrl}/api/job-cards/${encodeURIComponent(jobCardId)}/printable`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  if (!response.data?.success) {
    throw new Error(response.data?.message || 'Failed to load printable job card');
  }

  return response.data.data;
};

export const fetchPublicJobCardDocument = async (token) => {
  const response = await axios.get(
    `${rootUrl}/api/public/job-documents/${encodeURIComponent(token)}`
  );

  if (!response.data?.success) {
    throw new Error(response.data?.message || 'Failed to load public job card document');
  }

  return response.data.data;
};

export const createJobCardShareLink = async (token, jobCardId) => {
  const response = await axios.post(
    `${rootUrl}/api/job-cards/${encodeURIComponent(jobCardId)}/share-link`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  if (!response.data?.success) {
    throw new Error(response.data?.message || 'Failed to create share link');
  }

  return response.data.data;
};

export const sendJobCardDocumentEmail = async (token, jobCardId, formData) => {
  const response = await axios.post(
    `${rootUrl}/api/job-cards/${encodeURIComponent(jobCardId)}/send-email`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
  );

  if (!response.data?.success) {
    throw new Error(response.data?.message || 'Failed to send job card document');
  }

  return response.data.data;
};
